import {View, Text, Image} from 'react-native';
import React from 'react';
import {Images} from '../../../../constants/Images';
import {useIsDesktop} from '../../../../hooks/useIsDesktop';

interface INotFound {
  title: string;
  description: string;
}

const NotFound = ({title, description}: INotFound) => {
  const isDesktop = useIsDesktop();

  return (
    <View
      style={{
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        ...(isDesktop ? { minHeight: 400 } : {}),
      }}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
        }}>
        <Image source={Images.bagImage} style={isDesktop ? { width: 120, height: 120, resizeMode: 'contain' } : undefined} />
        <Image
          source={Images.warningB}
          style={{
            position: 'absolute',
            left: isDesktop ? 85 : 70,
          }}
        />
      </View>
      <Text
        style={{
          fontSize: isDesktop ? 24 : 22,
          fontWeight: '700',
          lineHeight: isDesktop ? 28 : 26,
          color: 'black',
          marginTop: 20,
          maxWidth: isDesktop ? 250 : 150,
          textAlign: 'center',
        }}>
        {title}
      </Text>
      <Text
        style={{
          fontSize: isDesktop ? 18 : 16,
          fontWeight: '400',
          lineHeight: isDesktop ? 22 : 20,
          color: 'gray',
          maxWidth: isDesktop ? 400 : 250,
          textAlign: 'center',
          marginTop: 10,
        }}>
        {description}
      </Text>
    </View>
  );
};

export default NotFound;
